import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const CarteiraRow = (props) => {
    return (
        <li className="list-group-item list-group-item-action flex-column align-items-start">
            <div className="row">
                <div className="col-12 col-md-11">
                    <div className="d-flex w-100 justify-content-between">
                        <h4>{props.ativo}</h4>
                        <h4>{(parseFloat(props.percentualTotal) * 100).toFixed(2)}%</h4>
                    </div>
                    <div className="d-flex w-100 justify-content-between">
                        <small>{props.qtdCustodia}</small>
                        <small>{parseFloat(props.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} / {parseFloat(props.precoMedioReal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                        <small>{parseFloat(props.ultimaCotacao).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} ({moment(props.dataUltimaCotacao).format('DD/MM/YYYY')})</small>
                    </div>
                    <div className="d-flex w-100 justify-content-between">
                        <small>{(parseFloat(props.peso) * 100).toFixed(2)}%</small>
                        <small>{(parseFloat(props.pesoMeta) * 100).toFixed(2)}%</small>
                        <small>{parseFloat(props.diferencaValor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                    </div>
                </div>
                <div className="col col-md-1">
                    <Link to={`/movAtivo/${props.ativo_id}`}>
                        <i className="fas fa-shopping-cart" style={{ cursor: "pointer" }} />
                    </Link>
                    {" | "}
                    <Link to={`/proventos/${props.ativo_id}`}>
                        <i className="fas fa-dollar-sign" style={{ cursor: "pointer" }} />
                    </Link>
                </div>
            </div>
        </li>
    );
};

CarteiraRow.propTypes = {
    ativo: PropTypes.string.isRequired,
    ativo_id: PropTypes.number.isRequired,
    qtdCustodia: PropTypes.number.isRequired,
    percentualTotal: PropTypes.number.isRequired,
    precoMedioReal: PropTypes.number.isRequired,
    precoMedio: PropTypes.number.isRequired,
    ultimaCotacao: PropTypes.string.isRequired,
    peso: PropTypes.number.isRequired,
    pesoMeta: PropTypes.number.isRequired,
    diferencaValor: PropTypes.number.isRequired,
    dataUltimaCotacao: PropTypes.string.isRequired,
};

export default CarteiraRow;


// WEBPACK FOOTER //
// ./src/components/carteira/CarteiraRow.js